import React, { useContext, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { gql } from '@apollo/client';
import { useForm } from 'react-hook-form';
import { useMutation, useQuery } from '@apollo/client';
import ReCAPTCHA from 'react-google-recaptcha';
import {T} from '../../../utils/I18n/I18n';
import {useTranslation} from "react-i18next";
import { GET_BACKEND_CONFIG } from '../../../commonQueries';
import FormInput from '../../UI/FormInput/FormInput';
import Button from '../../UI/Button/Button';
import { usePopup } from "../../../context/PopupContext";

const CHANGE_PASSWORD = gql`
    mutation changeCustomerPassword($currentPassword: String! $newPassword: String!){
        changeCustomerPassword(
            currentPassword: $currentPassword
            newPassword: $newPassword
        ){
            firstname
        }
    }
`;

const EditPassword = () => {
    const recaptchaRef = useRef();
    const history = useNavigate();
    const { register, handleSubmit, formState: { errors }, getValues, setValue } = useForm();
    const { showAddToCartPopupMessage } = usePopup();
    const { t } = useTranslation();
    const { data } = useQuery(GET_BACKEND_CONFIG)
    const [changeCustomerPassword, { error: mutationError }] = useMutation(CHANGE_PASSWORD);

    const onSubmit = async submitData => {
        const recaptchaToken = await recaptchaRef.current.executeAsync().catch(console.error);
        recaptchaRef.current.reset();
        const { currentPassword, newPassword } = submitData;
        try {
            await changeCustomerPassword({
              variables: {
                currentPassword,
                newPassword
              },
              context: {
                headers: {
                  'X-ReCaptcha': recaptchaToken
                }
              }
            });
            history("/customer/account")
            showAddToCartPopupMessage(t('edit.success'), "success", 4000);
        } catch (error) {
            console.log(error)

        }
    };

    useEffect(() => {
        if(mutationError){
            showAddToCartPopupMessage(mutationError.message, "error", 4000);
            setValue('currentPassword', '');
        }
    }, [mutationError])

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="profile-form">
            {data && data.configProvider && data.configProvider.captchaWebsiteKey ? (
                <ReCAPTCHA sitekey={data.configProvider.captchaWebsiteKey} ref={recaptchaRef} size="invisible" />
            ) : null}
            <p className="profile-form__header">{<T id="edit.editPassword" />}</p>
            <FormInput noAutoComplete register={register} type="password" text={<T id="edit.currentPassword" />} name="currentPassword" errors={errors} />
            <FormInput
              noAutoComplete
              register={register}
              validationRules={{
                  required: true,
                  minLength: {
                      value: 8,
                      message: t('edit.passwordError'),
                  },
              }}
              type="password"
              text={<T id="edit.newPassword" />}
              name="newPassword"
              errors={errors}
            />
            <FormInput
              noAutoComplete
              register={register}
              validationRules={{
                  required: true,
                  validate: value => (value === getValues().newPassword || t("edit.repeatPasswordsError")),
              }}
              type="password"
              text={<T id="edit.repeatPassword" />}
              name="repeatNewPassword"
              errors={errors}
            />
            <Button type="submit" trait="profile-hover" text={<T id="edit.submit" />} />
        </form>
    );
};

export default EditPassword;
